import * as React from 'react';
import { SortableTree } from '../SortableTree';
import { getAllLeaves } from '../utils';
import { Wrapper, NoDataMessage } from './styles';

export const ProjectSortableTree = ({
	data,
	onChange,
	searchQuery,
	onMenuOptionSelect,
	hideTreeItemChart,
	currencySymbol,
	canEdit,
}) => (
	<Wrapper>
		{(!data || data.length === 0) && <NoDataMessage />}

		{data && (
			<SortableTree
				data={data || []}
				dragDisabled={canEdit}
				currencySymbol={currencySymbol}
				searchQuery={searchQuery}
				treeConfig={{
					canNodeHaveChildren: node => node.level !== 5,
					canDrop: ({ node, nextParent }) => {
						if (
							nextParent &&
							(nextParent.level === 3 || nextParent.level === 4) &&
							(node && node.level < 4)
						) {
							const l4Items = getAllLeaves(node.children);

							const nodeHasL4Children = l4Items.length > 0;

							return nodeHasL4Children;
						}

						return true;
					},
				}}
				onChange={onChange}
				editable
				onMenuOptionSelect={onMenuOptionSelect}
				hideTreeItemChart={hideTreeItemChart}
			/>
		)}
	</Wrapper>
);
